import Axios from 'axios';
import sdk from '../sdk';
import $api from './api';
export { default as $api } from './api';
import store from '../store/index';
import signAndStringifyData from './sign';
import Qs from 'qs';
import { trackClick } from '@/lib/track';
import { Toast } from 'vant';

// 创建 axios 实例
const axios = Axios.create({
	baseURL: process.env.BASE_URL,
	headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
	timeout: 15000,
	withCredentials: true,
	paramsSerializer(params) {
		return Qs.stringify(Object.assign({}, params));
	},
});

// 添加 axios 实例请求拦截
axios.interceptors.request.use(
	(config) => {
		// 在发送请求之前做些什么
		return config;
	},
	(error) => {
		// 对错误请求做些什么
		return Promise.reject(error);
	}
);

// 添加 axios 实例响应拦截
axios.interceptors.response.use(
	(response) => {
		//	对响应数据做点什么
		return httpResOkHandle(response);
	},
	(error) => {
		// 对响应错误做点什么
		return httpResErrorHandle(error);
	}
);

// 获取请求基础参数
const BASE_PARAMS = () => {
	// 用户基础信息
	let { client } = store.getters;
	// console.log('sdk user info =>', JSON.parse(sdk.appCall('GET_USER_INFO')));

	if (!Object.keys(client).length) {
		let info = sdk.appCall('GET_USER_INFO');

		if (info) {
			client = JSON.parse(info);
		}
	}

	return {
		access_token: client.accessToken,
		visitor_token: client.visitor_token,
		tourist_token: client.tourist_token,
		platform: client.platform,
		client_v: client['client-v'],
		device_id: client.sa_device_id,
		utm_source: client['utm-source'],
		app_name: client['app-name'] || 'kuaiyin',
		platform_v: client['platform-v'],
		app_v: client['app-v'],
		platform_brand: client['platform-brand'],
		request_source: 'h5',
		platform_model: client['platform-model'],
	};
};

/**
 * @description: 福利模块post请求方法
 * @param {string} url - 请求 path
 * @param {object} params - 请求参数
 * @return: Promise
 */

export const $post = function (url, params, headers = {}, reqConf = {}) {
	const baseParams = BASE_PARAMS();
	let data = {
		...baseParams,
		...params,
	};
	data = signAndStringifyData(data, 'REQUEST');
	return axios.post(url, data, {
		headers: {
			'client-v': baseParams.client_v,
			'device-id': baseParams.device_id,
			platform: baseParams.platform,
			'utm-source': baseParams.utm_source,
			'platform-brand': baseParams.platform_brand,
			...headers,
		},
		...reqConf,
	});
};

/**
 * @description: 福利模块get请求方法
 * @param {string} url - 请求 path
 * @param {object} params - 请求参数
 * @return: Promise
 */

export const $get = function (url, params) {
	const baseParams = BASE_PARAMS();
	let data = { ...baseParams, ...params };

	return axios.get(url, {
		params: data,
		headers: {
			'client-v': baseParams.client_v,
			'device-id': baseParams.device_id,
			platform: baseParams.platform,
			'utm-source': baseParams.utm_source,
			'platform-brand': baseParams.platform_brand,
		},
	});
};

/**
 * @description: 游戏模块post请求方法
 * @param {string} url - 请求 path
 * @param {object} params - 请求参数
 * @return: Promise
 */

export const $postGame = function (url, params) {
	const baseParams = BASE_PARAMS();
	let data = { ...baseParams, ...params };
	data = signAndStringifyData(data, 'GAME_REQUEST');

	return axios.post(url, data, {
		baseURL: process.env.GAME_BASE_URL,
		headers: {
			'client-v': baseParams.client_v,
			'device-id': baseParams.device_id,
			platform: baseParams.platform,
			'utm-source': baseParams.utm_source,
			'platform-brand': baseParams.platform_brand,
		},
	});
};

let networkType = '';

try {
	const {
		navigator: {
			connection: { type, effectiveType },
		},
	} = window;

	networkType = effectiveType || type;
} catch (e) {
	console.log(e);
}

/**
 * @description: 客户端接口请求方法，将所有基础参数放入header中
 * @param url params
 * @param params
 * @return: Promise
 */

const $clientPost = function (url, params) {
	const baseParams = BASE_PARAMS();
	let data = { ...params };
	data = signAndStringifyData(data, 'CLIENT_REQUEST');

	return axios.post(url, data, {
		baseURL: process.env.CLIENT_BASE_URL,
		headers: {
			platform: baseParams.platform,
			'h5-login': baseParams.access_token,
			'client-v': baseParams.client_v,
			'device-id': baseParams.device_id,
			'platform-model': baseParams.platform_model,
			'network-type': networkType,
			'app-name': baseParams.app_name,
		},
	});
};

/**
 * @description: 游戏模块get请求方法
 * @param {string} url - 请求 path
 * @param {object} params - 请求参数
 * @return: Promise
 */

export const $getGame = function (url, params) {
	const baseParams = BASE_PARAMS();
	let data = { ...baseParams, ...params };

	return axios.get(url, {
		params: data,
		baseURL: process.env.GAME_BASE_URL,
		headers: {
			'client-v': baseParams.client_v,
			'device-id': baseParams.device_id,
			platform: baseParams.platform,
			'utm-source': baseParams.utm_source,
			'platform-brand': baseParams.platform_brand,
		},
	});
};

/**
 * @description: http 响应成功拦截处理
 * @param response
 * @return: Object
 */

const httpResOkHandle = function (response) {
	const { data, config } = response;

	if (0 === Number(data.code) || 10040 == Number(data.code) || 10041 == Number(data.code)) {
		if (data.message) {
			toast(data.message);
		}
		return data;
	} else {
		return serviceErrorHandle(data, config);
	}
};

/**
 * @description: 业务错误处理
 * @param {object} data - 返回数据
 * @param {object} reqConfig - 请求参数
 */

const serviceErrorHandle = function (data, reqConfig) {
	const { code, action, message } = data;
	const info = sdk.appCall('GET_USER_INFO');
	let client = {};
	if (info) {
		client = JSON.parse(info);
	}

	store.commit('activityPage/activityTemplate/setFortuneCanClick', true);
	switch (true) {
		case +code === 10001: // 未登录
			if (reqConfig.notJumpLogin) {
				return Promise.reject(data);
			}
			login();
			break;
		case +code === 10003: // 参数不正确
			toast('参数不正确');
			break;
		case +code === 10005: // access_token已过期
			if (info) {
				trackClick({
					page_title: 'token_expired',
					element_name: '10005',
					remarks: `uid: ${client.uid};acToken:${client.accessToken};tourToken:${client.tourist_token}`,
				});
			}
			if (sdk.appCall) {
				sdk.appCall('REFRESH_TOKEN');
			}
			break;
		case +code === 10035: // visitor_token已过期
			if (sdk.appCall) {
				sdk.appCall('REFRESH_TOKEN');
			}
			break;
		case +code === 10037: // tourist_token已过期
			if (sdk.appCall) {
				sdk.appCall('REFRESH_TOKEN');
			}
			break;
		case action === 'toast':
			if (data.message) {
				if (process.env.NODE_ENV === 'production') {
					const rmks = reqConfig.data + '&res=' + JSON.stringify(data);
					trackClick({ page_title: '请求异常上报', element_name: reqConfig.url, remarks: rmks });
				}
				toast(data.message);
			}
			break;
		case action === 'redirect':
			if (data.message) toast(data.message);
			setTimeout(
				() => {
					location.href = data.url;
				},
				data.message ? 1400 : 1
			);
			break;
		case action === 'replace':
			if (data.message) toast(data.message);
			setTimeout(
				() => {
					if (window.router && window.router.replace) {
						const {
							data: { page_name, query },
						} = data;

						window.router.replace({
							query,
							name: page_name,
						});
					} else {
						location.href = data.url;
					}
				},
				data.message ? 1400 : 1
			);
			break;
		default:
			console.log('未能识别的业务code!');
	}

	return Promise.reject(data);
};

/**
 * @description: http 响应错误拦截处理
 * @param error
 * @return: void
 */

const httpResErrorHandle = function (error) {
	store.commit('activityPage/activityTemplate/setFortuneCanClick', true);
	if (error.response) {
		const { status } = error.response;

		switch (status) {
			case 404:
				console.log('未找到请求资源！');
				break;
			case 500:
				console.log('服务器发生错误！error 为： ', error);
				break;
		}
	} else {
		console.log('没有http响应！error 为： ', error);
	}
	return Promise.reject(error);
};

/**
 * @description: 打开原生登录页
 */

const login = function () {
	const appName = store.getters.client['app-name'] || 'kuaiyin';

	try {
		const JSONStr = {
			url: `${appName}://login`,
		};
		sdk.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify(JSONStr));
	} catch (e) {
		console.log(e);
	}
};

/**
 * @description: toast 接口提示信息
 * @param {string} message
 */

const toast = function (message) {
	Toast({ message });
};

export default {
	install(Vue) {
		Object.defineProperties(Vue.prototype, {
			$post: {
				value: $post,
				writable: false,
			},
			$get: {
				value: $get,
				writable: false,
			},
			$postGame: {
				value: $postGame,
				writable: false,
			},
			$getGame: {
				value: $getGame,
				writable: false,
			},
			$api: {
				value: $api,
				writable: false,
			},
			$clientPost: {
				value: $clientPost,
				writable: false,
			},
		});
	},
};



// WEBPACK FOOTER //
// ./src/service/request.js